var map = {
	"./upload-add-img.png": 394,
	"./upload-cliente.png": 2317,
	"./upload-default.png": 2318,
	"./upload-dpi.png": 2319,
	"./upload-foto.png": 504,
	"./upload-recibo.png": 2320
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2316;